import { subfolderLocaleLanguageCountryCodeRegex } from '@coursera-web/internationalization-lib';
import type { CountryCode, LanguageCode } from '__generated__/graphql-types';

import { simplifyQueryValue } from 'js/lib/queryUtils';
import { useLocation, useParams } from 'js/lib/useRouter';

import type { Locale } from 'bundles/shared-articles/types';
import { getLanguageCodeFromCountryCode } from 'bundles/shared-articles/utils';

export type ArticleUrlDataProps = {
  slug: string;
  isPreview: boolean;
  subfolderLocaleCode?: Locale;
  page: string;
  pathname: string;
};

const useArticleUrlData = (): ArticleUrlDataProps => {
  const location = useLocation();
  const params = useParams();

  const {
    query: { page },
    pathname,
  } = location;

  let subfolderLocaleCode;
  if (params.subfolderLocaleCode && subfolderLocaleLanguageCountryCodeRegex.test(params.subfolderLocaleCode)) {
    const [languageCode, countryCode] = params.subfolderLocaleCode.split('-');
    subfolderLocaleCode = { languageCode: languageCode as LanguageCode, countryCode: countryCode as CountryCode };
  } else if (params.subfolderLocaleCode) {
    const countryCode = params.subfolderLocaleCode.toUpperCase() as CountryCode;
    subfolderLocaleCode = {
      languageCode: getLanguageCodeFromCountryCode(countryCode),
      countryCode,
    };
  }

  return {
    isPreview: !!location.query.preview,
    // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
    slug: params.slug,
    subfolderLocaleCode,
    page: simplifyQueryValue(page) ?? '', // TODO handle null/undefined case
    pathname,
  };
};

export default useArticleUrlData;
